import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Typography, useMediaQuery, useTheme, Avatar, IconButton, Stack, } from '@mui/material';
import ProfilePicture from './ProfilePicture';
import logo from './../../assets/img/logo-new.png'
import skillVationLogo from './../../assets/img/icon/skillVation.png'
import BoxEdit from './../../assets/img/icon/bx_edit.png'
import { useLocation, useNavigate } from "react-router-dom";
import { BOX_SHADOW, Frontend_URL, getFileUrl } from '../../shared/constants';
import MenuIcon from '@mui/icons-material/Menu';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useEffect, useState } from 'react';
import useAuthStore from '../../store/useAuthStore';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import SidebarMenuWithChangePassword from '../../layouts/SidebarMenuWithChangePassword';
import { useGetUserDetail } from '../../assets/api/UseStudentGetApi';

export const RenderMenuList = ({ menuList }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const [openSubMenus, setOpenSubMenus] = useState({});
  const handleSubMenuToggle = (index) => {
    setOpenSubMenus(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <List sx={{ pl: "32px", pr: "10px"  }}>
      {menuList.map((item, index) => {
        const isLink = (!item.subMenu && pathname === item.url) || (item.subMenu?.some((sub) => sub.url === pathname))

        return (

          <React.Fragment key={index}>
            <ListItem sx={{ padding: "0  !important", my: 0.5 }}>
              <ListItemButton
                onClick={() => {
                  if (item.subMenu) {
                    handleSubMenuToggle(index);
                  } else if (item.url === "/logout") {
                    logout();
                    const currentPath = window.location.pathname;
                    window.location.href = `${Frontend_URL}?redirect=${encodeURIComponent(currentPath)}`;
                  } else {
                    navigate(item.url);
                  }
                }}
                sx={{
                  // backgroundColor: !item.subMenu && pathname === item.url ? 'blue.main' : 'transparent',
                  backgroundColor: isLink ? 'blue.main'
                    : 'transparent',

                  borderRadius: "10px",
                  '&:hover': isLink ? { backgroundColor: 'blue.main' } : {},
                  cursor: isLink ? 'default' : 'pointer',
                  display: "flex",
                  justifyContent: "space-between"
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <ListItemIcon sx={{ minWidth: "30px" }}>
                    {isLink ? (
                      <Icon icon={item.icon} color="#FFFFFF" fontSize="15px" />
                    ) : (
                      <Icon icon={item.icon} color="#141C36" fontSize="15px" />
                    )}
                  </ListItemIcon>
                  <Typography
                    variant="h6"
                    sx={{
                      color: isLink ? 'text.secondary' : 'text.primary',
                      whiteSpace: 'normal',
                      overflowWrap: 'break-word',
                      wordBreak: 'break-word',
                      lineHeight: "20px",
                      textTransform: "capitalize"
                    }}
                  >
                    {item.name}
                  </Typography>
                </Box>

                {item.subMenu && (
                  openSubMenus[index] ? <ExpandLess sx={{ color: isLink ? "#fff" : "#000" }} /> : <ExpandMore sx={{ color: isLink ? "#fff" : "#000" }} />
                )}
              </ListItemButton>
            </ListItem>

            {item.subMenu && (
              <Collapse in={openSubMenus[index]} timeout="auto" unmountOnExit style={{ backgroundColor: "#F1F1F1" }}>
                <List component="div" disablePadding>
                  {item.subMenu.map((subItem, subIndex) => (
                    <ListItem key={subIndex} sx={{ padding: "0  !important", my: 0.5, borderBottom: item.subMenu?.length - 1 !== subIndex ? "1px solid #fff" : "" }}>
                      <ListItemButton
                        onClick={() => {
                          navigate(subItem.url);
                        }}
                        sx={{
                          backgroundColor: pathname === subItem.url ? 'blue.main' : 'transparent',
                          borderRadius: "10px",
                          pl: 4,
                          '&:hover': pathname === subItem.url ? { backgroundColor: 'blue.main' } : {},
                          cursor: pathname === subItem.url ? 'default' : 'pointer'
                        }}
                      >
                        <Typography
                          variant="h6"
                          lineHeight={"20px"}
                          sx={{
                            color: pathname === subItem.url ? 'text.secondary' : 'text.primary'
                          }}
                        >
                          {subItem.name}
                        </Typography>
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        )
      })}
    </List>
  );
};

export const sidebarWidth = "240px"
export const profileSecHeight = "210px"

export default function Sidebar({ children, menuLists, editComponent, profileDetail }) {

  const { user } = useAuthStore();
  const { data } = useGetUserDetail()
  const userDetail = data?.data
  const [open, setOpen] = React.useState(false);
  const [editDrawerOpen, setEditDrawerOpen] = React.useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const toggleEditDrawer = (newOpen) => () => {
    setEditDrawerOpen(newOpen);
  };
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 130);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const TopContent = ({ isdrawer }) => {
    return (
      <Box sx={{
        position: "relative", textAlign: "center", mt: isdrawer ? sidebarWidth : scrolled ? profileSecHeight : 10
      }}>
        <Box
          sx={{
            position: "absolute",
            top: "-130px",
            left: "50%",
            transform: "translateX(-50%)",
          }}
        >
          <Avatar
            src={getFileUrl(userDetail?.profile_image)}
            alt="Profile"
            sx={{
              width: 100,
              height: 100,
              border: "4px solid #fff",
            }}
          />
          <IconButton
            onClick={toggleEditDrawer(true)}
            sx={{
              position: "absolute",
              bottom: "20px",
              left: "80%",
              transform: "translate(-50%, 50%)",
              backgroundColor: "blue.light",
              boxShadow: "0 4px 4px 0 #00000040",
              "&:hover": { backgroundColor: "#D0D8FF" }, // Hover effect
            }}
          >
            <img src={BoxEdit} width={"15px"} alt="Edit" />
          </IconButton>
        </Box>
        <Stack direction="column" alignItems="center">
          <Typography variant="h5" color="blue.main">
            {(user?.role === "school" || user?.role === "teacher" || user?.role === "pro_teacher") && userDetail?.firstname}   {userDetail?.lastname}
          </Typography>
          <img
            src={
              (user?.role === "school" || user?.role === "teacher" || user?.role === "pro_teacher") ? skillVationLogo : logo
            }
            alt="Logo" style={{ width: "150px", cursor: "pointer" }}
            onClick={() => (window.location.href = Frontend_URL)}
          />
        </Stack>
      </Box>
    )
  }

  const DrawerList = () => {
    return (
      <Box sx={{ width: "290px" }} role="presentation" onClick={toggleDrawer(false)}>
        <TopContent isdrawer={true} />
        <SidebarMenuWithChangePassword
          menuList={menuLists}
        />
      </Box>
    )
  }

  return (
    <div>
      {!isSmallScreen && (
        <Box>

          <ProfilePicture profileDetail={profileDetail} />

          <Box sx={{ display: "flex", width: "100%" }}>
            <Box
              sx={{
                width: sidebarWidth,
                height: scrolled ? "100vh" : 'calc(100vh - 130px)',
                position: "fixed",
                bottom: 0,
                left: 0,
                backgroundColor: "text.secondary",
                zIndex: 101,
                boxShadow: BOX_SHADOW,
                borderTopRightRadius: "30px",
                overflow: "visible",   // ✅ For avatar overflow
                display: "flex",
                flexDirection: "column",
              }}
            >
              <TopContent />
              {/* Scrollable menu section only */}
              <Box sx={{
                overflowY: "auto", overflowX: "hidden", flex: 1,
                  "&::-webkit-scrollbar": {
              width: "0px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "transparent",
            },
              
              }}>
                <SidebarMenuWithChangePassword menuList={menuLists} />
              </Box>
            </Box>
            <Box sx={{ flexGrow: 1, width: `calc(100% - ${sidebarWidth})`, }}>
              <Box sx={{ p: "15px", ml: sidebarWidth, backgroundColor: "primary.main" }}>
                {children}
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {isSmallScreen && (
        <Box sx={{ position: "relative" }}>
          <Box sx={{ position: "sticky", top: "0px", py: 1, bgcolor: "#fff", left: "5px", zIndex: 200, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <IconButton onClick={toggleDrawer(true)}>
              <MenuIcon sx={{ color: "#000", fontSize: "20px" }} />
            </IconButton>
            <img src={logo} alt="Logo" style={{ width: "80px", cursor: "pointer" }} onClick={() => (window.location.href = Frontend_URL)} />
          </Box>
          <Drawer open={open} onClose={toggleDrawer(false)}>
            <DrawerList />
          </Drawer>
          <ProfilePicture profileDetail={profileDetail} />
          <Box sx={{ backgroundColor: "primary.main", p: "5px" }}>
            {children}
          </Box>

        </Box>
      )}
      <Drawer anchor="left" open={editDrawerOpen} onClose={toggleEditDrawer(false)}>
        <Box sx={{ width: { lg: "80vw", xs: "100%" } }}>
          {/* <StudentDetailForm onClose={toggleEditDrawer(false)} /> */}
          {React.cloneElement(editComponent, { onClose: toggleEditDrawer(false) })}
        </Box>
      </Drawer>
    </div>
  );
}
